enum RouteNameConstants {
  LOGIN = 'login',
  WORKSPACES = 'workspaces',
  NOT_FOUND = 'not-found',
  HOME = '',
  PROFILE = 'profile'
}

export default RouteNameConstants
